// extracted by mini-css-extract-plugin
export default {"centered":"_1tQFC","unsubscribe-width":"_1XxE-","unsubscribeWidth":"_1XxE-"};